//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { dateTypeOptions, timeOptions } from '../../enum';
export default {
  props: {
    form: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      // 时间类型枚举
      dateTypeOptions: dateTypeOptions,
      timeOptions: timeOptions
    };
  }
};